import { AICompletionResponse } from './ai.types';

export function parseInsightsResponse(response: AICompletionResponse) {
  if (!response.success) {
    throw new Error('Failed to fetch AI completion');
  }

  return JSON.parse(response.result);
}
